import {
  createResult,
  createRoomsIteratorCb,
  getInitialData,
  getLeafNodesValues,
} from './utils';
import { createTreeFilter } from './filter';

const createOptions = (rooms) => {
  const initialData = getInitialData();

  const roomsIteratorCb = createRoomsIteratorCb(initialData);
  rooms.forEach(roomsIteratorCb);

  return createResult(initialData);
};

export { createOptions, createTreeFilter, getLeafNodesValues };
